import React from "react";
import { Col, Row } from "react-bootstrap";
import AlertStyles from "./Alert.styles";
import { DefaultGenericAlertProps, IGenericAlertProps } from "./Alert.types";

const GENERIC_ALERT: React.FC<IGenericAlertProps> = (
  props: IGenericAlertProps
) => {
  const { onClose, message, enabletestid, testid, variant, className } = props;

  return (
    <AlertStyles.GenericAlert
      variant={variant}
      dismissible
      onClose={onClose}
      className={className ? className : "generic-alert"}
      data-testid={enabletestid ? testid : null}
    >
      <AlertStyles.AlertContentContainer
        fluid
        className="generic-alert-container"
      >
        <Row>
          <Col sm="auto" className="generic-alert-column">
            {message}
          </Col>
        </Row>
      </AlertStyles.AlertContentContainer>
    </AlertStyles.GenericAlert>
  );
};

GENERIC_ALERT.defaultProps = DefaultGenericAlertProps;
export default GENERIC_ALERT;
